// ╭────────────────────────────────────────────────────────────────────────────────────╮
// ┊  This file was automatically generated
// ┊  Please do not modify manually
// ┊  ©gl it 2026 - http://www.gl-it.ch
// ╰────────────────────────────────────────────────────────────────────────────────────╯

import { IJSONSchema } from '@glittr/frontend-core/src/plugins/validation/IJSONSchema';

const schema = {
  $id: '/shipping-info-schema',
  type: 'object',
  required: ['shippingAmount', 'vatRate', 'vatAmount'],
  properties: {
    shippingAmount: {
      type: 'number',
    },
    vatRate: {
      type: 'number',
    },
    vatAmount: {
      type: 'number',
    },
    shippingMethod: {
      type: 'string',
      nullable: true,
    },
    isShippingAmountCalculated: {
      type: 'boolean',
    },
  },
} as IJSONSchema;

export default schema;
